import type { StatsRoom } from '../../types';

export function StatsSparkline({ samples, className = '' }: { samples: StatsRoom['samples']; className?: string }) {
  if (samples.length < 2) return <span className="stats-spark-empty">-</span>;
  const width = 120;
  const height = 28;
  const counts = samples.map(sample => sample.count);
  const min = Math.min(...counts);
  const range = Math.max(...counts) - min || 1;
  const points = samples.map((sample, index) => `${((index / (samples.length - 1)) * width).toFixed(1)},${(height - ((sample.count - min) / range) * height).toFixed(1)}`).join(' ');
  const falling = samples[samples.length - 1]!.count < samples[0]!.count;
  return <svg className={`stats-spark ${className}`} viewBox={`0 0 ${width} ${height}`} role="img" aria-label="Recent attendance trend"><polyline points={points} fill="none" stroke={falling ? 'var(--alert)' : 'var(--signal)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
}
